import { Injectable, NgZone, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';

interface BraulioRenderConfig {
  config: typeof environment.braulioWidget;
}

declare global {
  interface Window {
    Braulio?: {
      render: (config: BraulioRenderConfig) => void;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class BraulioWidgetService {
  private ngZone = inject(NgZone);
  private scriptLoaded = false;
  private scriptUrl = environment.braulioWidget.scriptUrl;

  loadWidget(): void {
    if (this.scriptLoaded) {
      this.renderWidget();
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      const script = document.createElement('script');
      script.src = this.scriptUrl;
      script.async = true;

      script.onload = () => {
        this.scriptLoaded = true;
        this.renderWidget();
      };

      script.onerror = () => {
        console.error('Error loading Braulio widget script');
      };

      document.head.appendChild(script);
    });
  }

  private renderWidget(): void {
    if (window.Braulio) {
      this.ngZone.runOutsideAngular(() => {
        window.Braulio!.render({
          config: environment.braulioWidget,
        });
      });
    } else {
      console.error('Error: Agente no está disponible.');
    }
  }
}
